import { render, staticRenderFns } from "./trip.vue?vue&type=template&id=eb1ffab0&scoped=true&"
import script from "./trip.vue?vue&type=script&lang=js&"
export * from "./trip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1ffab0",
  null
  
)

export default component.exports